import React from 'react'
import { MdModeEditOutline } from "react-icons/md";

const EditButton = ( {onEdit, disabled} ) => (
    <button className="edit-button" onClick={onEdit} disabled={disabled}>
        <MdModeEditOutline size='18px' />&nbsp;Edit
    </button>
)

export default EditButton